import { RouteObject } from 'react-router-dom'
import { Portfolio } from './Portfolio'
import { ViewProject } from './ViewProject'

export const PortfolioRoutes: RouteObject[] = [
  {
    index: true,
    element: <Portfolio />,
  },
  {
    path: ':projectId',
    element: <ViewProject />,
  },
]
